import React  from 'react';
import 'react-credit-cards/lib/styles.scss';
import Currency from '../../../components/Price';
import style from './installments.module.scss';

const Installments = () => {
	return (
		<div className={style.container}>
			<div className={style.title}>Taksit seçenekleri</div>
			<div className={style.table}>
				<table>
					<tbody>
						<tr>
							<th>
							</th>
							<th>Aylık ödeme</th>
							<th>Toplam tutar</th>
						</tr>
						<tr>
							<td>Peşin</td>
							<td>
								<Currency value={12312.2}/>
							</td>
							<td>
								<Currency value={12312.2}/>
							</td>
						</tr>
						<tr>
							<td>2 Taksit</td>
							<td>
								<Currency value={300.99}/>
							</td>
							<td>
								<Currency value={12312.2}/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default Installments;
